module.exports = __webpack_public_path__ + "4d7fc639812300f843126d0efad9c6e9.png";